import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageJobRejectionComponent } from './manage-job-rejection.component';

const routes: Routes = [
  {
    path: '',
    component: ManageJobRejectionComponent,
    data: { title: 'Manage Job Rejection Reasons' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageJobRejectionRoutingModule {}

@NgModule({
  imports: [
    ManageJobRejectionRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ManageJobRejectionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageJobRejectionModule {}
